module.exports = {
  getSBApiBrand: function getSBApiBrand(brand) {
    switch (brand) {
      case 'czr-uat':
        return 'czr-uat';
      case 'wh':
        return 'wh';
      case 'nft':
        return 'nft';
      default:
        return 'czr';
    }
  },
  getApiBrand: function getApiBrand(brand) {
    switch (brand) {
      case 'wh':
        return 'wh';
      case 'nft':
        return 'nft';
      default:
        return 'czr';
    }
  }
};